import { defineMessages } from "react-intl";

export const pagesListSearchAndFiltersMessages = defineMessages({
  searchPlaceholder: {
    id: "UW1fLs",
    defaultMessage: "Search Pages",
    description: "search pages placeholder",
  },
});
